(function(){
  'use strict';
  if (window.__pfPersoInit) return;
  window.__pfPersoInit = true;

  var SUPPLEMENT_PRICES = { '57637677072716': 2.00, '57637677105484': 2.50, '57637677138252': 3.50, '57638138741068': 7.00, '57653571649868': 2.80, '57658310852940': 12.00, '57659212431692': 1.50, '57659212464460': 3.00, '57659212497228': 4.00, '57660425961804': 5.00 };
  var OPTIONS_WITHOUT_TEXT = { bola_supp: true };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function log() { try { console.log.apply(console, ['[pf-perso]'].concat(Array.from(arguments))); } catch(e){} }
  function priceFor(variantId) { return SUPPLEMENT_PRICES[String(variantId)] || 2.00; }
  function fmtEUR(amount) { return amount.toFixed(2).replace('.', ',') + ' €'; }
  function needsText(key) { return !OPTIONS_WITHOUT_TEXT[key]; }

  class PerlesPerso {
    constructor(form) {
      try {
        this.form = form;
        this.persoRoot = form.querySelector('[data-pf-perso]');
        this.centreEl = form.querySelector('[data-centre-chapelet]');
        this.croixEl = form.querySelector('[data-croix-chapelet]');
        this.chaineEl = form.querySelector('[data-chaine-bola]');
        if (!this.persoRoot && !this.centreEl && !this.croixEl && !this.chaineEl) return;
        this.firstInitialeFree = this.persoRoot && this.persoRoot.dataset.pfFirstInitialeFree === 'true';
        this.errorEl = this.persoRoot ? $('[data-pf-error]', this.persoRoot) : null;
        this.totalEl = this.persoRoot ? $('[data-pf-total]', this.persoRoot) : null;
        this.centreErrorEl = this.centreEl ? $('[data-centre-chapelet-error]', this.centreEl) : null;
        this.croixErrorEl = this.croixEl ? $('[data-croix-error]', this.croixEl) : null;
        this.croixSelectedEl = this.croixEl ? $('[data-croix-selected]', this.croixEl) : null;
        this.croixDetailsEl = this.croixEl ? $('[data-croix-details]', this.croixEl) : null;
        this.croixHelpEl = this.croixEl ? $('[data-croix-help]', this.croixEl) : null;
        this.chaineErrorEl = this.chaineEl ? $('[data-chaine-error]', this.chaineEl) : null;
        this.state = {};
        if (this.persoRoot) {
          this.options = $$('[data-pf-option]', this.persoRoot).map(function(el){ return el.dataset.pfOption; });
          this.options.forEach(function(key){ this.state[key] = { active: false, styleHandle: null, styleVariantId: null, stylePrice: 2, styleName: '', text: '', count: 1 }; }, this);
        } else {
          this.options = [];
        }
        this.bindEvents();
        this.updateAll();
        log('initialized perso=' + !!this.persoRoot + ' centre=' + !!this.centreEl + ' croix=' + !!this.croixEl + ' chaine=' + !!this.chaineEl);
      } catch(e) { console.error('[pf-perso] init', e); }
    }

    bindEvents() {
      var self = this;
      if (this.persoRoot) {
        $$('[data-pf-toggle]', this.persoRoot).forEach(function(i){ i.addEventListener('change', function(){ self.onToggle(i); }); });
        $$('[data-pf-style]', this.persoRoot).forEach(function(i){ i.addEventListener('change', function(){ self.onStyle(i); }); });
        $$('[data-pf-text]', this.persoRoot).forEach(function(i){ i.addEventListener('input', function(){ self.onText(i); }); });
        $$('[data-pf-counter-btn]', this.persoRoot).forEach(function(b){ b.addEventListener('click', function(){ self.onCounter(b); }); });
      }
      if (this.centreEl) {
        $$('[data-centre-chapelet-input]', this.centreEl).forEach(function(i){ i.addEventListener('change', function(){ self.onCentreChange(); }); });
      }
      if (this.croixEl) {
        $$('[data-croix-chapelet-input]', this.croixEl).forEach(function(i){ i.addEventListener('change', function(){ self.onCroixChange(); }); });
      }
      if (this.chaineEl) {
        $$('[data-chaine-bola-input]', this.chaineEl).forEach(function(i){ i.addEventListener('change', function(){ self.onChaineChange(); }); });
      }
      this.form.addEventListener('submit', function(e){ self.onSubmit(e); }, true);
    }

    onToggle(input) {
      var key = input.dataset.pfToggle;
      this.state[key].active = input.checked;
      var panel = $('[data-pf-panel="' + key + '"]', this.persoRoot);
      if (panel) panel.hidden = !input.checked;
      var ob = input.closest('[data-pf-option]'); if (ob) ob.classList.toggle('pf-perso__option--open', input.checked);
      if (input.checked) {
        var ec = $('[data-pf-style][data-pf-style-for="' + key + '"]:checked', this.persoRoot);
        if (!ec) { var fs = $('[data-pf-style][data-pf-style-for="' + key + '"]:not(:disabled)', this.persoRoot); if (fs) { fs.checked = true; this.onStyle(fs); return; } }
      }
      this.updateAll();
    }

    onStyle(input) { var key = input.dataset.pfStyleFor; this.state[key].styleHandle = input.value; this.state[key].styleVariantId = input.dataset.pfStyleVariant; this.state[key].stylePrice = priceFor(input.dataset.pfStyleVariant); this.state[key].styleName = input.dataset.pfStyleName || ''; this.updateAll(); }

    onText(input) { var key = input.dataset.pfText; this.state[key].text = input.value; this.clearError(); this.updateAll(); }

    onCounter(btn) { var p = btn.dataset.pfCounterBtn.split(':'); var key = p[0], dir = p[1], s = this.state[key]; if (dir === 'inc') s.count = Math.min(10, s.count + 1); else s.count = Math.max(1, s.count - 1); var v = $('[data-pf-count="' + key + '"]', this.persoRoot); if (v) v.textContent = s.count; this.updateAll(); }

    onCentreChange() { this.clearCentreError(); this.updateAll(); }
    onChaineChange() { this.clearChaineError(); this.updateAll(); }

    onCroixChange() {
      this.clearCroixError();
      this.updateCroixDisplay();
      this.updateAll();
    }

    updateCroixDisplay() {
      if (!this.croixEl) return;
      var croix = this.getCroixSelection();
      if (croix && this.croixSelectedEl) {
        var label = '<span class="croix-chapelet__selected-label">Croix sélectionnée :</span> ' + this.formatCroixLabel(croix);
        if (croix.supplementPrice) label += ' <em>(+' + fmtEUR(croix.supplementPrice) + ')</em>';
        this.croixSelectedEl.innerHTML = label;
        this.croixSelectedEl.hidden = false;
      } else if (this.croixSelectedEl) {
        this.croixSelectedEl.hidden = true;
      }
      if (croix && this.croixDetailsEl) {
        try { this.croixDetailsEl.open = false; } catch(e){}
      }
      if (croix && this.croixHelpEl) {
        this.croixHelpEl.textContent = 'Modifier la sélection';
      }
    }

    chargedQty(key, count) {
      if (key === 'initiale' && this.firstInitialeFree) return Math.max(0, count - 1);
      return count;
    }

    isActiveAndValid(key) {
      var s = this.state[key];
      if (!s.active) return false;
      if (needsText(key) && (!s.text || !s.text.trim())) return false;
      return true;
    }

    getMainQuantity() {
      var qIn = document.querySelector('input[name="quantity"][form="' + this.form.id + '"]:not([data-pf-qty-display])') || this.form.querySelector('input[name="quantity"]:not([data-pf-qty-display])');
      if (!qIn) return 1;
      var v = parseInt(qIn.value, 10);
      return v > 0 ? v : 1;
    }

    getCentreSelection() {
      if (!this.centreEl) return null;
      var input = this.centreEl.querySelector('[data-centre-chapelet-input]:checked');
      if (!input) return null;
      var supVariant = input.dataset.centreSupplementVariant || null;
      return {
        input: input,
        numero: input.dataset.centreNumero || '',
        nom: input.dataset.centreNom || '',
        couleur: input.dataset.centreCouleur || '',
        supplementVariant: supVariant,
        supplementPrice: supVariant ? priceFor(supVariant) : 0
      };
    }

    formatCentreLabel(centre) {
      // Cas spécial "Sans centre" (numero=0) : afficher juste le nom sans préfixe.
      if (!centre.numero || centre.numero === '0') return centre.nom || 'Sans centre';
      var s = 'n°' + centre.numero + ' — ' + centre.nom;
      if (centre.couleur) s += ' (' + centre.couleur + ')';
      return s;
    }

    getCroixSelection() {
      if (!this.croixEl) return null;
      var input = this.croixEl.querySelector('[data-croix-chapelet-input]:checked');
      if (!input) return null;
      var supVariant = input.dataset.croixSupplementVariant || null;
      return {
        input: input,
        numero: input.dataset.croixNumero || '',
        nom: input.dataset.croixNom || '',
        variation: input.dataset.croixVariation || '',
        note: input.dataset.croixNote || '',
        supplementVariant: supVariant,
        supplementPrice: supVariant ? priceFor(supVariant) : 0
      };
    }

    formatCroixLabel(croix) {
      var s = 'n°' + croix.numero + ' — ' + croix.nom;
      if (croix.variation) s += ' (' + croix.variation + ')';
      return s;
    }

    getChaineSelection() {
      if (!this.chaineEl) return null;
      var input = this.chaineEl.querySelector('[data-chaine-bola-input]:checked');
      if (!input) return null;
      var supVariant = input.dataset.chaineSupplementVariant || null;
      return {
        input: input,
        numero: input.dataset.chaineNumero || '',
        nom: input.dataset.chaineNom || '',
        variation: input.dataset.chaineVariation || '',
        statut: input.dataset.chaineStatut || '',
        supplementVariant: supVariant,
        supplementPrice: supVariant ? priceFor(supVariant) : 0
      };
    }

    formatChaineLabel(chaine) {
      var s = 'n°' + chaine.numero + ' — ' + chaine.nom;
      if (chaine.variation) s += ' (' + chaine.variation + ')';
      return s;
    }

    computeSupplements(mainQty) {
      mainQty = mainQty || 1;
      var items = []; var self = this;
      Object.keys(this.state).forEach(function(key){
        if (!self.isActiveAndValid(key)) return;
        var s = self.state[key];
        var qty = self.chargedQty(key, s.count) * mainQty; if (qty <= 0) return;
        var vid = s.styleVariantId || (self.persoRoot && self.persoRoot.dataset.pfDefaultVariantId); if (!vid) return;
        var propText;
        if (needsText(key)) {
          propText = self.labelOf(key) + ' "' + s.text.trim() + '"' + (s.styleName ? ' (' + s.styleName + ')' : '');
        } else {
          propText = self.labelOf(key) + (s.styleName ? ' — ' + s.styleName : '');
        }
        items.push({
          id: parseInt(vid, 10),
          quantity: qty,
          properties: { 'Personnalisation': propText }
        });
      });
      var centre = this.getCentreSelection();
      if (centre && centre.supplementVariant) {
        items.push({
          id: parseInt(centre.supplementVariant, 10),
          quantity: mainQty,
          properties: { 'Centre / médaille': this.formatCentreLabel(centre) }
        });
      }
      var croix = this.getCroixSelection();
      if (croix && croix.supplementVariant) {
        items.push({
          id: parseInt(croix.supplementVariant, 10),
          quantity: mainQty,
          properties: { 'Croix': this.formatCroixLabel(croix) }
        });
      }
      var chaine = this.getChaineSelection();
      if (chaine && chaine.supplementVariant) {
        items.push({
          id: parseInt(chaine.supplementVariant, 10),
          quantity: mainQty,
          properties: { 'Chaîne': this.formatChaineLabel(chaine) }
        });
      }
      return items;
    }

    labelOf(key) { return { prenom: 'Prenom', verset: 'Verset', date: 'Date', initiale: 'Initiale', bola_supp: 'Bola supplémentaire' }[key] || key; }

    computeTotal() {
      var total = 0, self = this;
      Object.keys(this.state).forEach(function(key){
        if (!self.isActiveAndValid(key)) return;
        var s = self.state[key];
        var qty = self.chargedQty(key, s.count); if (qty <= 0) return;
        var price = s.styleVariantId ? priceFor(s.styleVariantId) : 2.00;
        total += price * qty;
      });
      var centre = this.getCentreSelection();
      if (centre && centre.supplementPrice) total += centre.supplementPrice;
      var croix = this.getCroixSelection();
      if (croix && croix.supplementPrice) total += croix.supplementPrice;
      var chaine = this.getChaineSelection();
      if (chaine && chaine.supplementPrice) total += chaine.supplementPrice;
      return total;
    }

    updateCounterPrices() {
      if (!this.persoRoot) return;
      var self = this;
      $$('[data-pf-counter-price]', this.persoRoot).forEach(function(el){
        var key = el.dataset.pfCounterPrice;
        if (key === 'initiale' && self.firstInitialeFree) return;
        var s = self.state[key];
        var price;
        if (s && s.styleVariantId) {
          price = priceFor(s.styleVariantId);
        } else {
          var def = parseFloat(el.dataset.pfDefaultPrice);
          price = isNaN(def) ? 2.00 : def;
        }
        var suffix = (key === 'bola_supp') ? ' / unité' : (key === 'initiale') ? ' / initiale' : '';
        el.textContent = '+' + fmtEUR(price) + suffix;
      });
    }

    updateAll() {
      var t = this.computeTotal();
      if (this.totalEl) this.totalEl.textContent = (t > 0 ? '+' : '') + fmtEUR(t);
      this.updateCounterPrices();
    }

    buildMainProps() {
      var props = {}; var self = this; var parts = [];
      Object.keys(this.state).forEach(function(key){
        if (!self.isActiveAndValid(key)) return;
        var s = self.state[key];
        var line;
        if (needsText(key)) {
          line = self.labelOf(key) + ' x' + s.count + ' - ' + s.text.trim();
        } else {
          line = self.labelOf(key) + ' x' + s.count;
        }
        if (s.styleName) line += ' (' + s.styleName + ')';
        parts.push(line);
      });
      if (parts.length) props['Personnalisation'] = parts.join(' | ');
      var centre = this.getCentreSelection();
      if (centre) props['Centre / médaille choisi(e)'] = this.formatCentreLabel(centre);
      var croix = this.getCroixSelection();
      if (croix) props['Croix choisie'] = this.formatCroixLabel(croix);
      var chaine = this.getChaineSelection();
      if (chaine) props['Chaîne choisie'] = this.formatChaineLabel(chaine);

      // FILET DE SÉCURITÉ : ramasse les autres propriétés natives properties[*] du formulaire.
      $$('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]', this.form).forEach(function(input) {
        if (input.disabled) return;
        if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
        var match = input.name.match(/^properties\[(.+)\]$/);
        if (match && input.value && !props.hasOwnProperty(match[1])) {
          props[match[1]] = input.value;
        }
      });

      return Object.keys(props).length ? props : null;
    }

    hasAnyActivePersoOption() { var self = this; return Object.keys(this.state).some(function(k){ return self.state[k].active; }); }

    shouldIntercept() { return this.hasAnyActivePersoOption() || !!this.centreEl || !!this.croixEl || !!this.chaineEl; }

    validate() {
      var self = this, invalid = false;
      Object.keys(this.state).forEach(function(k){
        var s = self.state[k];
        if (s.active && needsText(k) && (!s.text || !s.text.trim())) invalid = true;
      });
      if (invalid) { if (this.errorEl) { this.errorEl.hidden = false; this.errorEl.textContent = 'Veuillez renseigner le texte pour chaque option activée.'; } return false; }
      this.clearError();
      if (this.chaineEl) {
        var chaine = this.getChaineSelection();
        if (!chaine) {
          if (this.chaineErrorEl) this.chaineErrorEl.hidden = false;
          this.chaineEl.classList.add('chaine-bola--invalid');
          return false;
        }
      }
      this.clearChaineError();
      if (this.centreEl) {
        var centre = this.getCentreSelection();
        if (!centre) {
          if (this.centreErrorEl) this.centreErrorEl.hidden = false;
          this.centreEl.classList.add('centre-chapelet--invalid');
          return false;
        }
      }
      this.clearCentreError();
      if (this.croixEl) {
        var croix = this.getCroixSelection();
        if (!croix) {
          if (this.croixErrorEl) this.croixErrorEl.hidden = false;
          this.croixEl.classList.add('croix-chapelet--invalid');
          if (this.croixDetailsEl) { try { this.croixDetailsEl.open = true; } catch(e){} }
          return false;
        }
      }
      this.clearCroixError();
      return true;
    }

    clearError() { if (this.errorEl) this.errorEl.hidden = true; }
    clearCentreError() { if (this.centreErrorEl) this.centreErrorEl.hidden = true; if (this.centreEl) this.centreEl.classList.remove('centre-chapelet--invalid'); }
    clearCroixError() { if (this.croixErrorEl) this.croixErrorEl.hidden = true; if (this.croixEl) this.croixEl.classList.remove('croix-chapelet--invalid'); }
    clearChaineError() { if (this.chaineErrorEl) this.chaineErrorEl.hidden = true; if (this.chaineEl) this.chaineEl.classList.remove('chaine-bola--invalid'); }
    getCart() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }

    async onSubmit(event) {
      try {
        if (!this.shouldIntercept()) { log('nothing to intercept'); return; }
        if (!this.validate()) {
          event.preventDefault(); event.stopImmediatePropagation();
          var target;
          if (this.chaineEl && !this.getChaineSelection()) target = this.chaineEl;
          else if (this.croixEl && !this.getCroixSelection()) target = this.croixEl;
          else if (this.centreEl && !this.getCentreSelection()) target = this.centreEl;
          else target = this.persoRoot;
          if (target) target.scrollIntoView({behavior:'smooth', block:'center'});
          return;
        }
        var mvi = this.form.querySelector('[name="id"]');
        if (!mvi || !mvi.value) { log('no main variant id'); return; }
        var mainVariantId = parseInt(mvi.value, 10);
        var mainQty = this.getMainQuantity();
        var supplements = this.computeSupplements(mainQty);
        var mainProps = this.buildMainProps();

        if (supplements.length === 0 && !mainProps) { log('no supplements and no props, default behavior'); return; }

        event.preventDefault(); event.stopImmediatePropagation();

        var btn = this.form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.remove('hidden'); }

        var mainItem = { id: mainVariantId, quantity: mainQty };
        if (mainProps) mainItem.properties = mainProps;
        var items = [mainItem].concat(supplements);

        log('Intercept submit. mainQty=' + mainQty + ' Payload:', JSON.parse(JSON.stringify(items)));

        var cart = this.getCart();
        var sections = [];
        if (cart && typeof cart.getSectionsToRender === 'function') { try { sections = cart.getSectionsToRender().map(function(s){ return s.id; }); } catch(e){} }

        try {
          var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname }) });
          var data = null; try { data = await res.json(); } catch(e) {}
          log('Cart response status:', res.status, 'data:', data);
          if (!res.ok) {
            var msg = (data && (data.description || data.message)) || ('Erreur ' + res.status);
            throw new Error(msg);
          }

          if (data && data.items && data.items[0] && data.items[0].key) {
            data.key = data.items[0].key;
          }

          if (cart && typeof cart.renderContents === 'function') {
            try { cart.setActiveElement && cart.setActiveElement(document.activeElement); } catch(e){}
            try {
              cart.renderContents(data);
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            } catch (renderErr) {
              console.warn('[pf-perso] renderContents failed, fallback to /cart:', renderErr);
              window.location.href = '/cart';
              return;
            }
          } else {
            window.location.href = '/cart';
          }

          self_resetUI(this);
        } catch (err) {
          console.error('[pf-perso] Cart add error:', err);
          if (this.errorEl) { this.errorEl.hidden = false; this.errorEl.textContent = 'Erreur Shopify : ' + (err.message || 'inconnue') + ' — ouvre la console pour le détail.'; }
          else if (this.centreErrorEl) { this.centreErrorEl.hidden = false; this.centreErrorEl.textContent = 'Erreur Shopify : ' + (err.message || 'inconnue'); }
          else if (this.croixErrorEl) { this.croixErrorEl.hidden = false; this.croixErrorEl.textContent = 'Erreur Shopify : ' + (err.message || 'inconnue'); }
          else if (this.chaineErrorEl) { this.chaineErrorEl.hidden = false; this.chaineErrorEl.textContent = 'Erreur Shopify : ' + (err.message || 'inconnue'); }
        } finally {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); var sp2 = btn.querySelector('.loading__spinner'); if (sp2) sp2.classList.add('hidden'); }
        }
      } catch(e) { console.error('[pf-perso] onSubmit fatal', e); }
    }
  }

  function self_resetUI(ctrl) {
    try {
      Object.keys(ctrl.state).forEach(function(key){
        ctrl.state[key].active = false;
        ctrl.state[key].text = '';
        ctrl.state[key].count = 1;
      });
      if (ctrl.persoRoot) {
        $$('[data-pf-toggle]', ctrl.persoRoot).forEach(function(i){ i.checked = false; });
        $$('[data-pf-text]', ctrl.persoRoot).forEach(function(i){ i.value = ''; });
        $$('[data-pf-count]', ctrl.persoRoot).forEach(function(s){ s.textContent = '1'; });
        $$('[data-pf-panel]', ctrl.persoRoot).forEach(function(p){ p.hidden = true; });
        $$('[data-pf-option]', ctrl.persoRoot).forEach(function(o){ o.classList.remove('pf-perso__option--open'); });
      }
      if (ctrl.centreEl) {
        $$('[data-centre-chapelet-input]', ctrl.centreEl).forEach(function(i){ i.checked = false; });
      }
      if (ctrl.croixEl) {
        $$('[data-croix-chapelet-input]', ctrl.croixEl).forEach(function(i){ i.checked = false; });
        if (ctrl.croixSelectedEl) ctrl.croixSelectedEl.hidden = true;
      }
      if (ctrl.chaineEl) {
        $$('[data-chaine-bola-input]', ctrl.chaineEl).forEach(function(i){ i.checked = false; });
      }
      ctrl.updateAll();
    } catch(e) { console.warn('[pf-perso] resetUI err', e); }
  }

  function init() {
    document.querySelectorAll('form').forEach(function(form){
      if (form.__pfInit) return;
      var hasPerso = !!form.querySelector('[data-pf-perso]');
      var hasCentre = !!form.querySelector('[data-centre-chapelet]');
      var hasCroix = !!form.querySelector('[data-croix-chapelet]');
      var hasChaine = !!form.querySelector('[data-chaine-bola]');
      if (!hasPerso && !hasCentre && !hasCroix && !hasChaine) return;
      form.__pfInit = true;
      try { new PerlesPerso(form); } catch(e) { console.error('[pf-perso] construct', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
